import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp32};
`

export const TitleAndDescriptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const EmailContentContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const HeaderRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp8};
`

export const HeaderTitleContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const TabsRow = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp24};
`

export const SubjectRow = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};
`

export const SubjectInputContainer = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp8};
`

export const BodyContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp16};
`

export const EditorToolbar = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp8};
  padding: ${props => props.theme.spacing.sp8};
  background-color: ${props => props.theme.colors.disabled.surface};
  border-radius: ${props => props.theme.primitives.radius.radius2} ${props => props.theme.primitives.radius.radius2}
    ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius0};
`

export const EditorBody = styled.div`
  background-color: ${props => props.theme.colors.disabled.surface};
  border-radius: ${props => props.theme.primitives.radius.radius0} ${props => props.theme.primitives.radius.radius0}
    ${props => props.theme.primitives.radius.radius2} ${props => props.theme.primitives.radius.radius2};
  padding: ${props => props.theme.spacing.sp16};
  height: 300px;
`
